import React, { useEffect, useRef, useState } from "react";
import Chart from "chart.js/auto";
import './DataVisualisation.css';


const createWeeklyData = (data) => {
  const weeklyData = [];
  const weekdays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
  weekdays.forEach((day) => {
    const dayData = data.filter((item) => item.day === day);
    console.log("daya data is before", dayData);
    if (dayData.length > 0) {
      const dayFrequencies = dayData.map((item) => item.frequency_user);
      console.log("day frequency is", dayFrequencies);
      const averageFrequency =
        dayFrequencies.reduce((acc, val) => acc + val, 0) /
        dayFrequencies.length;
      weeklyData.push({ day, hour: "00:00", frequency: averageFrequency });
    }
  });
  return weeklyData;
};

const createMonthlyData = (data) => {
  console.log("The data in month", data);
  const monthlyData = [];
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  months.forEach((month) => {
    // const monthData = data.filter((item) => item.day.startsWith(month));
    const monthData = data.filter((item) => item.month === month);
    if (monthData.length > 0) {
      const monthFrequencies = monthData.map((item) => item.frequency_user);
      const averageFrequency =
        monthFrequencies.reduce((acc, val) => acc + val, 0) /
        monthFrequencies.length;
      monthlyData.push({ day: month, hour: "00:00", frequency: averageFrequency });
    }
  });

  return monthlyData;
};

const createYearlyData = (data) => {
  const yearlyData = [];
  // const years = ['2020', '2021', '2022']; // example years
  const currentYear = new Date().getFullYear();
  const years = [currentYear - 2, currentYear-1, currentYear].map(String);
  console.log("years are", years);

  years.forEach((year) => {
    const yearData = data.filter((item) => item.year == year );
    if (yearData.length > 0) {
      const yearFrequencies = yearData.map((item) => item.frequency_user);
      const averageFrequency =
        yearFrequencies.reduce((acc, val) => acc + val, 0) /
        yearFrequencies.length;
      yearlyData.push({ day: year, hour: "00:00", frequency: averageFrequency });
    }
  });

  return yearlyData;
};

function UserData(props) {
  const { data } = props;
  console.log("data of users are", data);
  const chartRef = useRef(null);
  const [view, setView] = useState("day");
  let chartInstance = null;

  useEffect(() => {

    if (data) {
      const chartData = {
        labels: [],
        data: [],
      };

      if (view === "day") {
        data.forEach((item) => {
          const label = `${item.day} - ${item.hour}`;
          chartData.labels.push(label);
          chartData.data.push(item.frequency_user);
        });
      } else if (view === "week") {
        const weeklyData = createWeeklyData(data);
        weeklyData.forEach((item) => {
          const label = `${item.day} - ${item.hour}`;
          chartData.labels.push(label);
          chartData.data.push(item.frequency);
        });
      } else if (view === "month") {
        const monthlyData = createMonthlyData(data);
        monthlyData.forEach((item) => {
          const label = `${item.day} - ${item.hour}`;
          chartData.labels.push(label);
          chartData.data.push(item.frequency);
        });
      } else if (view === "year") {
        const yearlyData = createYearlyData(data);
        yearlyData.forEach((item) => {
          const label = `${item.day}`;
          chartData.labels.push(label);
          chartData.data.push(item.frequency);
        });
      }

      const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
          title: {
            display: true,
            text: "",
            font: {
              size: 18,
              weight: "bold",
            },
            color: "white",
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            grid: {
              color: "rgba(255,255,255,0.1)",
            },
            ticks: {
              color: "white",
              font: {
                size: 12,
              },
            },
          },
          x: {
            grid: {
              color: "rgba(255,255,255,0.1)",
            },
            ticks: {
              color: "white",
              font: {
                size: 12,
              },
            },
          },
        },
      };

      const myChartRef = chartRef.current.getContext("2d");

      if (chartInstance) {
        chartInstance.destroy();
      }

      chartInstance = new Chart(myChartRef, {
        type: "line",
        data: {
          labels: chartData.labels,
          datasets: [
            {
              data: chartData.data,
              backgroundColor: "rgba(70,130,180,0.8)",
              hoverBackgroundColor: "rgba(70,130,180,1)",
              borderColor: "rgba(54, 162, 235, 1)",
              borderWidth: 1.5,
              borderDash: [5, 5],
              fill: false,
            },
          ],          
        },
        options: chartOptions,
      });
    }

    return () => {
      if (chartInstance) {
        chartInstance.destroy();
      }
    };
  }, [data, view]);

  const handleViewChange = (event) => {
    setView(event.target.value);
  };

  return (
    <div className="data-visualisation-container">
      <div className="data-visualisation-header">
        <div className="data-visualisation-title">
          <h2>New Users</h2>
        </div>
        <div className="data-visualisation-controls">
          <label htmlFor="view-select" className="data-visualisation-label">
            View:
          </label>
          <select
            id="view-select"
            className="data-visualisation-select"
            value={view}
            onChange={handleViewChange}
            style={{ color: 'black' }}
          >
            <option value="day">Day</option>
            <option value="week">Week</option>
            <option value="month">Month</option>
            <option value="year">Year</option>
          </select>
        </div>
      </div>
      <div className="data-visualisation-body">
        <canvas ref={chartRef} />
      </div>


      
    </div>
  );
}

export default UserData;
